'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
};

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');

import ErrorBox from '../common/ErrorBox';
const ForgeError = require('../../util/error');

const propTypes = {
    org_user_id: PropTypes.number.isRequired,
    rsdServices: PropTypes.array.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
    show: true,
};

class OrgAddRSDServiceModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceData: {
                org_user_id: props.org_user_id,
                name: '',
                service_type: Globals.RSD_SERVICE_TYPES.OpenRSD,
                details: {
                    rsd_id_prefix: '',
                    rsd_id_suffix: '',
                    base_api: '',
                    api_suffix: '',
                },
            },
            submitError: null,
            inputClassParams: {
                name: "missing-input-data",
                rsd_id_prefix: "missing-input-data",
                rsd_id_suffix: '',
                base_api: "missing-input-data",
                api_suffix: "",
            },
        };
    }

    submitHandler=(e)=>{
        // trim whitespace
        let serviceData = { ...this.state.serviceData };
        serviceData.name = serviceData.name.trim();
        serviceData.details = {...serviceData.details };
        if (serviceData.details.rsd_id_prefix) {
            serviceData.details.rsd_id_prefix = serviceData.details.rsd_id_prefix.trim();
        }
        if (!serviceData.details.rsd_id_suffix) {
            serviceData.details.rsd_id_suffix = '';
        }
        else {
            serviceData.details.rsd_id_suffix = serviceData.details.rsd_id_suffix.trim();
        }
        if (serviceData.details.base_api) {
            serviceData.details.base_api = serviceData.details.base_api.trim();
        }
        if (!serviceData.details.api_suffix) {
            serviceData.details.api_suffix = '';
        }
        else {
            serviceData.details.api_suffix = serviceData.details.api_suffix.trim();
        }
        
        var existingName = _.find(this.props.rsdServices,{name:serviceData.name});
        if (existingName) {
            var duplicateNameError = new ForgeError({ message: "service name must be unique" });
            this.setState({duplicateNameError,canSubmit:false,serviceData});
            return;
        }
        this.props.submitHandler(serviceData);
    }
    
    setServiceType=(e)=>{
        var service_type = e.target.value;
        this.doUpdate({ 
            serviceData: {
                ...this.state.serviceData,
                service_type: service_type,
            }
        })
    }
    
    doUpdate=(changes)=>{
        let serviceData = changes.serviceData;
        let inputClassParams = {};
        var missingData = false;
        if (!serviceData.name) {
            missingData = true;
            inputClassParams.name = "missing-input-data";
        }
        if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) {
            if(!serviceData.details.rsd_id_prefix) {
                missingData = true;
                inputClassParams.rsd_id_prefix = "missing-input-data";
            }

            if (!serviceData.details.base_api) {
                missingData = true;
                inputClassParams.base_api = "missing-input-data";
            }
        }


        var duplicateNameError = this.state.duplicateNameError; 
        if (serviceData.name && duplicateNameError) {
            var existingName = _.find(this.props.rsdServices,{name:serviceData.name});
            if (!existingName) {
                duplicateNameError = null;
            }
            else {
                canSubmit = false; // TODO fixme
            }
        }
        let canSubmit = !missingData && !duplicateNameError; // TODO fixme

        this.setState({
            serviceData, 
            canSubmit,
            duplicateNameError,
            inputClassParams
        });
    }
    
    render() {
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{Strings['en'].RSD.ADD_RSD_SERVICE}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className={this.state.inputClassParams.name} controlId="modal-edit-rsd-service-endpoint">
                            <Form.Label>{'Name'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Name'}
                                value={this.state.serviceData.name || ''}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            name: e.target.value 
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        <ErrorBox error={this.state.duplicateNameError} />
                        
                        <Form.Group controlId="modal-edit-rsd-service-type">
                            <label htmlFor="modal-edit-rsd-service-type">{'Type'}</label>
                            <select id="modal-edit-rsd-service-type" value={this.state.serviceData.service_type} onChange={this.setServiceType}>
                                <option value={Globals.RSD_SERVICE_TYPES.MZL}>Internal</option>
                                <option value={Globals.RSD_SERVICE_TYPES.OpenRSD}>OpenRSD</option>
                            </select>
                        </Form.Group>
                        { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ? 
                        <Form.Group className={this.state.inputClassParams.rsd_id_prefix} controlId="modal-edit-rsd-service-endpoint-prefix">
                            <Form.Label>{'ID Prefix'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'ID Prefix'}
                                value={this.state.serviceData.details.rsd_id_prefix || ''}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            details: {
                                                ...this.state.serviceData.details,
                                                rsd_id_prefix: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        : null }
                        
                        { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ? 
                        <Form.Group className={this.state.inputClassParams.rsd_id_suffix} controlId="modal-edit-rsd-service-endpoint">
                            <Form.Label>{'RSD ID Suffix'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'RSD ID Suffix'}
                                value={this.state.serviceData.details.rsd_id_suffix || ''}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            details: {
                                                ...this.state.serviceData.details,
                                                rsd_id_suffix: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        : null }
                        
                        { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ? 
                        <Form.Group className={this.state.inputClassParams.base_api} controlId="modal-edit-rsd-service-endpoint">
                            <Form.Label>{'Base API'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Base Service API'}
                                value={this.state.serviceData.details.base_api || ''}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            details: {
                                                ...this.state.serviceData.details,
                                                base_api: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        : null }
                        { (this.state.serviceData.service_type === Globals.RSD_SERVICE_TYPES.OpenRSD) ? 
                        <Form.Group className={this.state.inputClassParams.api_suffix} controlId="modal-edit-rsd-service-endpoint">
                            <Form.Label>{'API Suffix'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'API Suffix'}
                                value={this.state.serviceData.details.api_suffix || ''}
                                onChange={(e)=>{
                                    this.doUpdate({ 
                                        serviceData: {
                                            ...this.state.serviceData,
                                            details: {
                                                ...this.state.serviceData.details,
                                                api_suffix: e.target.value 
                                            }
                                        }
                                    })
                                }}
                            />
                        </Form.Group>
                        : null }
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={!this.state.canSubmit} onClick={this.submitHandler}>
                        {Strings['en'].RSD.ADD_RSD_SERVICE}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

OrgAddRSDServiceModal.propTypes = propTypes;
OrgAddRSDServiceModal.defaultProps = defaultProps;

export default OrgAddRSDServiceModal;